import Modes from "../contexts/Modes";
import request, { orderManagerRequest } from "../helpers/api";
import {
    getApplicablePickupAreaOrdersFromReadyToDispatch,
    getDispatchedActiveOrdersForDashboard
} from "../helpers/OrderHelper";

export const getSnapshot = () => {
    return new Promise((resolve, reject) => {
        // resolve({
        //     offset: -1,
        //     data: JSON.parse(JSON.stringify(data)),
        // });

    });
}

export const poll = () => {

}

export const fetchMetaData = (locationId) => {
    return new Promise((resolve, reject) => {
        request('GET', `location/${locationId}/metadata`).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
}

export const fetchOrdersByLocation = (location, mode, isAssigner) => {
    return new Promise((resolve, reject) => {
        request('GET', `${location.multiTenant ? 'tagged-' : ''}locations/${location.id}/updates`).then((response) => {
            if (mode === Modes.DISPATCHER || mode === Modes.ORDER_READY) {
                const data = {
                    data: overwriteStatuses([
                        ...response.inProgressOrders, 
                        ...response.driverAssignedOrders,
                        ...response.deliveryJobCreatedOrders,
                        ...getApplicablePickupAreaOrdersFromReadyToDispatch(isAssigner, response.readyToDispatchOrders)]),
                    offset: response.offset,
                };
                resolve(data);
            } else {
                const data = {
                    data: overwriteStatuses([...response.inProgressOrders, ...response.readyToDispatchOrders, ...getDispatchedActiveOrdersForDashboard(response.dispatchedOrders)]),
                    offset: response.offset,
                };
                resolve(data);
            }

        }).catch((error) => {
            reject(error);
        });
    });
}

export const fetchOrdersByOffset = (location, offset) => {
    return new Promise((resolve, reject) => {
        request('GET', `${location.multiTenant ? 'tagged-' : ''}locations/${location.id}/updates/${offset}`).then((response) => {
            const data = {
                data: overwriteStatuses(
                    response.updatesList.map((item) => {
                        return item.order;
                    })),
                offset: response.lastReadOffset,
            }
            resolve(data);
        }).catch((error) => {
            reject(error);
        });
    });
}

const overwriteStatuses = (orders) => {
    return orders.map((order) => {
        // if order is prepared, ovewrite it as ready to dispatch
        if (order.status === 'PREPARED') {
            if (order.statusHistory.find((item) => item.status === 'READY_TO_DISPATCH')) {
                return {
                    ...order,
                    status: 'READY_TO_DISPATCH'
                };
            }
        }
        return order;
    });
};

export const fetchMetaDataList = (partnerId, locations) => {
    return new Promise((resolve, reject) => {
        request('POST', `location/byPartner/${partnerId}`, locations).then((response) => {

            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
}

export const orderDispatch = (orderId) => {
    return new Promise((resolve, reject) => {
        request('POST', `orders/${orderId}/dispatch`).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
}

export const fetchFulfilledOrders = (location, mode, pageNumber, pageSize, externalId) => {
    return new Promise((resolve, reject) => {
        request('GET', `${location.multiTenant ? 'tagged-' : ''}locations/${location.id}/updates/${mode}/${pageNumber}/${pageSize}?externalId=${externalId}`)
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    });
}

export const fetchAppConfig = (locationId) => {
    return new Promise((resolve, reject) => {
        request('GET', `location/${locationId}/app-config`).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
}

export const fetchLocationTagMap = (locationId) => {
    return new Promise((resolve, reject) => {
        request('GET', `tagged-locations/${locationId}/tag`).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
}

export const fetchLocationTagMaps = (locations) => {
    return new Promise((resolve, reject) => {
        request('POST', `tagged-locations/tags`, locations).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
}

export const fetchStaticResourceMap = () => {
    return new Promise((resolve, reject) => {
        request('GET', `resource`).then((response) => {
            const map = {};
            response.forEach(element => {
                map[element.name] = {
                    file: element.file
                };
            });
            console.log(map);
            resolve(map);
        }).catch((error) => {
            reject(error);
        });
    });
}

export const fetchLocationConfigurations = (partnerId, locationId) => {
    return new Promise((resolve, reject) => {
        orderManagerRequest('GET', `partners/${partnerId}/delivery-configuration/location-configurations/${locationId}`).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
}

export const updateLocationDeliveryConfig = (partnerId, locationId, body) => {
    return new Promise((resolve, reject) => {
        orderManagerRequest('PUT', `partners/${partnerId}/delivery-configuration/location-configurations/${locationId}`, body).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
}

export const updateOrderDeliveryMode = (body) => {
    return new Promise((resolve, reject) => {
        request('PUT', `orders/update-delivery-partner`, body).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
}

export const fetchAvailable3plPartners = (partnerId) => {
    return new Promise((resolve, reject) => {
        orderManagerRequest('GET', `partners/${partnerId}/delivery-partners`).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

const data = [
    {
        "id": "656128521718837248",
        "externalId": "TALABAT835",
        "locationId": "5fcf3b2548b3c85693bbc804",
        "assignedStations": null,
        "sourceInfo": {
            "id": "talabat-food-aggregator",
            "name": "Talabat"
        },
        "preparationTimeInMinutes": 10,
        "brandInfo": {
            "id": "5fca85cc6dd6ae0d4ad69774",
            "name": "Burger Hut",
            "partnerId": "5fca10e96dd6ae0d4ad69770"
        },
        "status": "ACCEPTED",
        "items": [
            {
                "id": "5fd8bcda6fb4d96b664a80be",
                "orderId": null,
                "menuItemId": "5fce203b295e497bd01b0e4e",
                "menuItemName": "Chicago Pizza",
                "quantity": 3,
                "status": "CREATED",
                "comments": "",
                "modifierInfoList": [
                    {
                        "id": "5fcdfb0aa83bbd6516a12533",
                        "name": "Cheese",
                        "quantity": 3
                    }
                ],
                "assignedStationId": null,
                "preparationTimeInMinutes": 10,
                "metaData": null
            }
        ],
        "orderTime": "Tue Dec 15 13:40:29 UTC 2020",
        "comment": "3x Chicago Pizza - I need extra cheese \nOrder comment: Please send this immediately",
        "deliveryMode": {
            "deliveryModeType": "THIRD_PARTY"
        },
        "eventCompletedTime": "1608039642540",
        "statusHistory": [
            {
                "status": "ACCEPTED",
                "eventCompletedTime": "1608039642545"
            }
        ]
    },
    {
        "id": "656130084168380416",
        "externalId": "TALABAT838",
        "locationId": "5fcf3b2548b3c85693bbc804",
        "assignedStations": null,
        "sourceInfo": {
            "id": "talabat-food-aggregator",
            "name": "Talabat"
        },
        "preparationTimeInMinutes": 10,
        "brandInfo": {
            "id": "5fca85cc6dd6ae0d4ad69774",
            "name": "Burger Hut",
            "partnerId": "5fca10e96dd6ae0d4ad69770"
        },
        "status": "ACCEPTED",
        "items": [
            {
                "id": "5fd8be7e6fb4d96b664a80c5",
                "orderId": null,
                "menuItemId": "5fce203b295e497bd01b0e4e",
                "menuItemName": "Chicago Pizza",
                "quantity": 3,
                "status": "CREATED",
                "comments": "",
                "modifierInfoList": [
                    {
                        "id": "5fcdfb0aa83bbd6516a12533",
                        "name": "Cheese",
                        "quantity": 3
                    }
                ],
                "assignedStationId": null,
                "preparationTimeInMinutes": 10,
                "metaData": null
            }
        ],
        "orderTime": "Tue Dec 15 13:46:42 UTC 2020",
        "comment": "3x Chicago Pizza - I need extra cheese \nOrder comment: Please send this immediately",
        "deliveryMode": {
            "deliveryModeType": "THIRD_PARTY"
        },
        "eventCompletedTime": "1608040062459",
        "statusHistory": [
            {
                "status": "ACCEPTED",
                "eventCompletedTime": "1608040062459"
            }
        ]
    },
    {
        "id": "656134122029035520",
        "externalId": "TALABAT839",
        "locationId": "5fcf3b2548b3c85693bbc804",
        "assignedStations": null,
        "sourceInfo": {
            "id": "talabat-food-aggregator",
            "name": "Talabat"
        },
        "preparationTimeInMinutes": 10,
        "brandInfo": {
            "id": "5fca85cc6dd6ae0d4ad69774",
            "name": "Burger Hut",
            "partnerId": "5fca10e96dd6ae0d4ad69770"
        },
        "status": "ACCEPTED",
        "items": [
            {
                "id": "5fd8c20e6fb4d96b664a80cb",
                "orderId": null,
                "menuItemId": "5fce203b295e497bd01b0e4e",
                "menuItemName": "Chicago Pizza",
                "quantity": 3,
                "status": "CREATED",
                "comments": "",
                "modifierInfoList": [
                    {
                        "id": "5fcdfb0aa83bbd6516a12533",
                        "name": "Cheese",
                        "quantity": 3
                    }
                ],
                "assignedStationId": null,
                "preparationTimeInMinutes": 10,
                "metaData": null
            }
        ],
        "orderTime": "Tue Dec 15 14:02:45 UTC 2020",
        "comment": "3x Chicago Pizza - I need extra cheese \nOrder comment: Please send this immediately",
        "deliveryMode": {
            "deliveryModeType": "THIRD_PARTY"
        },
        "eventCompletedTime": "1608040974893",
        "statusHistory": [
            {
                "status": "ACCEPTED",
                "eventCompletedTime": "1608040974903"
            }
        ]
    },
    {
        "id": "656134717867667456",
        "externalId": "TALABAT840",
        "locationId": "5fcf3b2548b3c85693bbc804",
        "assignedStations": null,
        "sourceInfo": {
            "id": "talabat-food-aggregator",
            "name": "Talabat"
        },
        "preparationTimeInMinutes": 10,
        "brandInfo": {
            "id": "5fca85cc6dd6ae0d4ad69774",
            "name": "Burger Hut",
            "partnerId": "5fca10e96dd6ae0d4ad69770"
        },
        "status": "ACCEPTED",
        "items": [
            {
                "id": "5fd8c29e6fb4d96b664a80dc",
                "orderId": null,
                "menuItemId": "5fce203b295e497bd01b0e4e",
                "menuItemName": "Chicago Pizza",
                "quantity": 3,
                "status": "CREATED",
                "comments": "",
                "modifierInfoList": [
                    {
                        "id": "5fcdfb0aa83bbd6516a12533",
                        "name": "Cheese",
                        "quantity": 3
                    }
                ],
                "assignedStationId": null,
                "preparationTimeInMinutes": 10,
                "metaData": null
            }
        ],
        "orderTime": "Tue Dec 15 14:05:07 UTC 2020",
        "comment": "3x Chicago Pizza - I need extra cheese \nOrder comment: Please send this immediately",
        "deliveryMode": {
            "deliveryModeType": "THIRD_PARTY"
        },
        "eventCompletedTime": "1608041118007",
        "statusHistory": [
            {
                "status": "ACCEPTED",
                "eventCompletedTime": "1608041118007"
            }
        ]
    },
]
